import { render, staticRenderFns } from "./confirm-email.vue?vue&type=template&id=7a79e08c&scoped=true&"
import script from "./confirm-email.vue?vue&type=script&lang=js&"
export * from "./confirm-email.vue?vue&type=script&lang=js&"
import style0 from "./confirm-email.vue?vue&type=style&index=0&id=7a79e08c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a79e08c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VExpandTransition,VProgressCircular})
